module.exports = __webpack_public_path__ + "media/images/icons/close-91b388a01c67ae18156dddb4258ee2dd.svg";